import React, { useState, useEffect, useCallback } from "react";
import Layout from "containers/LayoutV2";
import { pushNotification } from "utils/notifications";
import ConfigSystemApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigSystemApi";
import StoreApi from "service/phanQuyenApi";
import UserApi from "service/userApi"; // Đã thêm import này
import configsRole from "utils/configsRole";
import "../../../assets/css/table-kydonglai.css";
import { FormCauHinhHeThong } from "./FormCauHinhHeThong.js";

const CustomRadio = ({
  id,
  name,
  value,
  checked,
  onChange,
  label,
  dataType,
  className = "",
}) => (
  <div className={`form-group ${className}`}>
    <label htmlFor={id} className="custom-control custom-radio">
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        data-type={dataType}
        checked={checked}
        onChange={onChange}
        className="custom-control-input"
      />
      <span className="custom-control-indicator"></span>
      <span className="custom-control-description">{label}</span>
    </label>
  </div>
);

export const CauHinhHeThong = () => {
  const initPhanQuyen = {
    cauhinhhethong: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  // Thêm state check xem có phải shopadmin không
  const [isShopAdmin, setIsShopAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const initialConfigData = {
    IsSendLoginSMS: false,
    SendSmsType: 0,
    AutoSms: false,
    DaySms: "1",
    TimeSms: new Date(),
    LaiBatHo: 0,
    isCauHinhT77: 0,
    PhanQuyenTheoViTri: 0,
    HoaHongTraGop: 0,
    SuDungTachNoXau: 0,
    Language: "0",
    CauHinhNgayNoPhaiThu: "0",
    CauHinhTatToan: 0,
    CauHinhTatToan_ThucHien: "",
    CauHinhTatToan_Ngay: 0,
    CauHinhTatToan_Kieu: "",
    HeThongSuDungCauHinhTatToan: 0,
    UseCauHinhPhatChamToiDa: 0,
    CauHinhPhatChamToiDa: "0",
    CauHinhNgayNoChuY: 0,
    CauHinhNgayNoXau: 0,
    CauHinhNgayNoRuiRo: 0,
    CauHinhNgayNoQuaHan: 0,
    IsTrichLapDuPhong: 0,
    Debtstatus_auto3_npt: 0,
    ChuKySo: 0,
    isUseChuKySo: 0,
    TyLePhiXuat: 0,
    ThueGTGT: 0,
    isXuatHoaDon: 0,
  };
  const [configData, setConfigData] = useState(initialConfigData);
  const initialTatToanData = {
    CauHinhTatToan_ThucHien: "",
    CauHinhTatToan_Ngay: 0,
    CauHinhTatToan_Kieu: "",
  };
  const [isPhatChamVisible, setIsPhatChamVisible] = useState(false);

  const fetchPermission = () => {
    setLoading(true);
    // isShopAdmin không phải quyền mà là vai trò: nó quyết định có được thấy
    // HeThongSuDungCauHinhTatToan hay không, nên vẫn hỏi role chứ không hỏi phân quyền.
    UserApi.checkRole("shopadmin")
      .then((res) => setIsShopAdmin(!!res.data))
      .catch(() => setIsShopAdmin(false));
    StoreApi.getAllQuyen()
      .then((response) => {
        if (response.status === 200) {
          const getRole = (code) =>
            response.data.some(
              (e) => e.ModuleCode?.toUpperCase() === code.toUpperCase(),
            );
          setPhanQuyen({
            cauhinhhethong: getRole(configsRole.sRole.cauhinhhethong),
          });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleTatToanChange = (isBatted) => {
    setConfigData((prev) => {
      if (isBatted) {
        return { ...prev, CauHinhTatToan: 1 };
      } else {
        return { ...prev, CauHinhTatToan: 0, ...initialTatToanData };
      }
    });
  };

  const fetchConfiguration = useCallback(() => {
    setLoading(true);
    setIsPhatChamVisible(false);
    ConfigSystemApi.getCauHinhHeThong()
      .then((res) => {
        if (res.status === 200) {
          let apiData = res.data;
          if (apiData.TimeSms && typeof apiData.TimeSms === "string") {
            const [hours, minutes] = apiData.TimeSms.split(":");
            const timeAsDate = new Date();
            timeAsDate.setHours(parseInt(hours, 10), parseInt(minutes, 10));
            apiData.TimeSms = timeAsDate;
          }
          if (!isShopAdmin) {
            apiData.HeThongSuDungCauHinhTatToan = 0;
          }
          const configDataFromApi = { ...initialConfigData, ...apiData };
          setConfigData(configDataFromApi);
          if (configDataFromApi.UseCauHinhPhatChamToiDa === 1) {
            setIsPhatChamVisible(true);
          }
        } else pushNotification("Lấy dữ liệu cấu hình thất bại!", "error");
      })
      .catch(() => pushNotification("Lấy dữ liệu cấu hình thất bại!", "error"))
      .finally(() => setLoading(false));
  }, [isShopAdmin]);

  useEffect(() => {
    document.title = "Cấu hình Hệ Thống | Phần mềm quản lý cầm đồ Morman";
    fetchPermission();
  }, []);

  useEffect(() => {
    if (phanQuyen.cauhinhhethong) {
      fetchConfiguration();
    }
  }, [phanQuyen.cauhinhhethong]);

  const handleSave = async () => {
    setIsSaving(true);
    let dataToSave = { ...configData };
    if (dataToSave.TimeSms instanceof Date) {
      const hours = dataToSave.TimeSms.getHours().toString().padStart(2, "0");
      const minutes = dataToSave.TimeSms.getMinutes()
        .toString()
        .padStart(2, "0");
      dataToSave.TimeSms = `${hours}:${minutes}`;
    }
    if (!dataToSave.AutoSms) {
      dataToSave.DaySms = 0;
      dataToSave.TimeSms = "";
    }
    try {
      const res = await ConfigSystemApi.updateCauHinhHeThong(dataToSave);
      if (res.status === 200) {
        pushNotification("Cập nhật cấu hình thành công!", "success");
        fetchConfiguration();
      } else {
        pushNotification("Cập nhật thất bại!", "error");
      }
    } catch {
      pushNotification("Cập nhật thất bại!", "error");
    } finally {
      setIsSaving(false);
    }
  };

  const handleTimeChange = (date) => {
    setConfigData((prev) => ({
      ...prev,
      TimeSms: date,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const isNumericRadio = e.target.dataset?.type === "number";
    const finalValue =
      type === "checkbox" ? checked : isNumericRadio ? Number(value) : value;
    setConfigData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));
  };

  if (loading)
    return (
      <Layout>
        <div className="loading-page1">
          <div className="loader loader-default is-active"></div>
        </div>
      </Layout>
    );

  return (
    <Layout>
      {phanQuyen.cauhinhhethong ? (
        <>
          <div id="form-repeater" className="p-1">
            <div
              className="breadcrumb-new hidden-mobile-main"
              style={{ marginBottom: "5px" }}
            >
              <div className="row header justify-content-start">
                <img
                  src="/app-assets/images/icon-cau-hinh.png"
                  alt="Mẫu hợp đồng"
                />
                <h1 className="text-info-home mb-1">Cấu hình hệ thống</h1>
              </div>
            </div>
            <div className="card border-light mb-1 card-v2">
              <div className="card-body card-body-v2">
                {configData && (
                  <FormCauHinhHeThong
                    data={configData}
                    handleTimeChange={handleTimeChange}
                    handleInputChange={handleInputChange}
                    handleTatToanChange={handleTatToanChange}
                    CustomRadio={CustomRadio}
                    isPhatChamVisible={isPhatChamVisible}
                  />
                )}
              </div>
            </div>
            <div className="sticky-bottom">
              <div className="card border-light show-table-main card-v2">
                <div
                  className="card-body card-body-v2"
                  style={{ padding: "12px 16px" }}
                >
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-danger btn-w-m btn-sm"
                      onClick={handleSave}
                      disabled={isSaving}
                    >
                      <i className="fas fa-check"></i>{" "}
                      {isSaving ? "Đang cập nhật..." : "Cập nhật"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="p-1">
          <div className="d-flex align-items-center">
            <i
              className="fa-solid fa-gear fa-3x"
              style={{ color: "#1cc88a" }}
            ></i>
            <h1 className="text-info-home mb-0 ms-2 fw-bold">
              Cấu hình hệ thống
            </h1>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </Layout>
  );
};
